export const HANDLED_PROMISE_REJECTION_MESSAGE_PREFIX = 'Handled Promise Rejection (this should not end up in Sentry): ';

/**
 * Defer wrapper around promise
 */
export class Defer {
    constructor() {
        this.resolvePromise = null;
        this.rejectPromise = null;
        this.promise = new Promise(executor.bind(this));

        /**
         * Stores callback methods for resolve and reject, so they can be called later
         * @param {Function} resolve
         * @param {Function} reject
         */
        function executor(resolve, reject) {
            this.resolvePromise = resolve; // eslint-disable-line no-invalid-this
            this.rejectPromise = reject; // eslint-disable-line no-invalid-this
        }
    }

    /**
     * Resolve this defer's promise
     * @param {*} result
     */
    resolve(result) {
        this.resolvePromise(result);
    }

    /**
     * Reject this defer's promise
     * @param {String|*} reason
     */
    reject(reason) {
        this.rejectPromise(reason);
    }
}
